/**
 * @file 役務の入力フィールドを追加する
 */
'use strict';

import ApplyClass from '../../Utils/ApplyClass';
import BtnRemoveTitleField from './BtnRemoveTitleField';
import Validate from './Validate';
 
/**
 * @classname BtnAddTitleField
 * @classdesc 役務の入力フィールドを追加する
 */
export default class BtnAddTitleField {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('btn-add-title-field')
	 */
	constructor($e, controller) {
		console.log('BtnAddTitleField.constructor')
		this._$e = $e
		this._controller = controller
		this._$inputText = this._$e.closest('.sortable-list').find('.sortable-list__item').last().find('.input-text')
		this._$btnAddTitleFieldWrapper = this._$e.closest('.btn-add-title-field-wrapper')
		this._lastSortableItemIndex = this._$e.closest('.sortable-list').find('.sortable-list__item').last().find('input').data('sortable-list-item-index')
		this._$titleFields = null
		this._$e.on('click', () => this.addNewTitleField())
	}
 
 
	/**
	 * テンプレート
	 *
	 * @memberof BtnAddTitleField
	 * @return {undefined}
	 */
	createTitleField() {
		console.log('BtnAddTitleField.createTitleField')
		const newTitleField = document.createElement('div')
		newTitleField.classList.add('sortable-list__item', 'row')
		newTitleField.innerHTML = `
<div class="col-12 form-group">
	<div class="row">
		<div class="col-md-8 d-flex align-items-center">
			<input class="validate input-text" name="${this._$inputText.attr('name')}" value="" data-validate="empty" data-code="" data-initial-value="" data-sortable-list-item-index="${++this._lastSortableItemIndex}" type="text">
			<i class="fas fa-arrows-alt ml15 sortable-list__item__handle cursor-move fs24"></i>
			<i class="fas fa-minus-square ml15 cursor-move fs24 text-danger btn-remove-title-field"></i>
		</div>
		<div class="col-md-3 d-flex align-items-center">
			<p class="error-tip mt0">
				<span class="error-tip-inner"></span>
			</p>
		</div>
	</div>
</div>`
		return newTitleField
	}
 
 
	/**
	 * 既存フィールドの複製
	 *
	 * @memberof BtnAddTitleField
	 * @return {undefined}
	 */
	cloneExistingTitleFields() {
		console.log('BtnAddTitleField.cloneExistingTitleFields')
		this._$titleFields = Array.prototype.map.call(this._$e.closest('.sortable-list').find('.sortable-list__item'), (sortableListItem) => $(sortableListItem).clone(true))
	}


	/**
	 * 既存フィールドの削除
	 *
	 * @memberof BtnAddTitleField
	 * @return {undefined}
	 */
	removeExistingTitleFields() {
		console.log('BtnAddTitleField.removeExistingTitleFields')
		Array.prototype.forEach.call(this._$e.closest('.sortable-list').find('.sortable-list__item'), element => $(element).remove())
	}

	/**
	 * 起動
	 *
	 * @memberof BtnAddTitleField
	 * @return {undefined}
	 */
	addNewTitleField() {
		console.log('BtnAddTitleField.addNewTitleField')
		// this.cloneExistingTitleFields()
		// this.removeExistingTitleFields()
		// this._$titleFields.forEach($titleField => $titleField.insertBefore(this._$btnAddTitleFieldWrapper))
		const $newTitleField = $(this.createTitleField())
		ApplyClass.apply(Validate, $newTitleField.find('.validate'), [$newTitleField.find('.validate'), this._controller])
		ApplyClass.apply(BtnRemoveTitleField, $newTitleField.find('.btn-remove-title-field'), [$newTitleField.find('.btn-remove-title-field'), this._controller])
		$newTitleField.insertBefore(this._$btnAddTitleFieldWrapper)
	}
}
